import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import './UvalueCalculator.css';
import './Mobile.css';
import Cookies from 'js-cookie';
import MobileProductDisplay from './MobileProductDisplay'
import MobileProductAccordion from './MobileProductAccordion';
import ProductVariables from './ProductVariables';
import MenuModal from './MenuModal';
import LoginMenuModal from './LoginMenuModal';
import { motion, AnimatePresence } from "framer-motion";


const WordPressPosts = () => {
    const [posts, setPosts] = useState([]);
    const [error, setError] = useState(null);
    const [categories, setCategories] = useState([]);
    const [selectedParentCategory, setSelectedParentCategory] = useState(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [categoryForProductSelect, setCategoryForProductSelect] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [result, setResult] = useState(null);
    const [selectedSubCategorySlug, setSelectedSubCategorySlug] = useState('');
    const [loadingCategories, setLoadingCategories] = useState(true);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [quoteHistory, setQuoteHistory] = useState(() => {
        // Load quoteHistory from localStorage if it exists
        const savedHistory = localStorage.getItem('quoteHistory');
        return savedHistory ? JSON.parse(savedHistory) : [];
    });
    const [productUrl, setProductUrl] = useState("");
    const [formData, setFormData] = useState([]);

    useEffect(() => {
        console.log("selectedProduct:", selectedProduct);
    }, [selectedProduct])

    // Corrected newQuote function to update state immutably
    function newQuote(quote) {
        setQuoteHistory((prevQuotes) => {
            const updatedQuotes = [...prevQuotes, quote];
            localStorage.setItem('quoteHistory', JSON.stringify(updatedQuotes)); // Save to localStorage
            return updatedQuotes;
        });
    }

    // Clear local storage when necessary, e.g., on logout
    function clearQuoteHistory() {
        setQuoteHistory([]);
        localStorage.removeItem('quoteHistory');
    }



    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Check if the user has the cookie for location and occupation
        const userInfo = Cookies.get('userInfo');
        if (!userInfo) {
            setShowModal(true); // Show modal if no cookie found
        }
    }, []);



    
    const fetchCategoryNames = async (categoryIds) => {
        try {
            const response = await axios.get(`https://uvalue-calculator.nimbus.sugarprojects.com/wp-json/wp/v2/categories?include=${categoryIds.join(',')}&per_page=100`);
            const categoryData = response.data.reverse();
            setCategories(categoryData);
            setLoadingCategories(false);
        } catch (err) {
            console.error('Error fetching categories:', err);
        }
    };
   

    
    useEffect(() => {
        axios.get('https://uvalue-calculator.nimbus.sugarprojects.com/wp-json/wp/v2/products?per_page=100')
            .then(response => {
                setPosts(response.data);
                setError(null);
                setLoadingProducts(false);

                const allCategories = response.data.flatMap(post => post.categories || []);
                const uniqueCategories = [...new Set(allCategories)];
                fetchCategoryNames(uniqueCategories);
            })
            .catch(err => {
                console.error('Error fetching posts:', err);
                setError('Could not fetch posts.');
                setLoadingProducts(false);
            });
    }, [location.search]);
    
    

    useEffect(() => {
        if (!loadingProducts && !loadingCategories) {
            const params = new URLSearchParams(location.search);
            const productId = params.get('product');
            if (productId) {
                const product = posts.find(p => p.id === parseInt(productId));
                if (product) {
                    initializeProductSelection(product);
                }
            }
        }
    }, [loadingProducts, loadingCategories, posts, categories, location.search]);

    const parentCategories = categories.filter(cat => cat.parent === 0);
    const subCategories = categories.filter(cat => cat.parent === selectedParentCategory);

    const handleParentCategorySelect = (categoryId) => {
        if (categoryId !== selectedParentCategory) {
            setSelectedParentCategory(categoryId);
            setSelectedSubCategory(null);
            setSelectedSubCategorySlug(''); // Reset slug when parent changes
            setCategoryForProductSelect(null);
            setSelectedProduct(null);
            setResult(null);

            //const params = new URLSearchParams(location.search);
            //params.delete('product');
            //navigate({ search: params.toString() }, { replace: true });
        }
    };

    const handleSubCategorySelect = (categoryId, slug) => {
        if (categoryId !== selectedSubCategory) {
            setSelectedSubCategory(categoryId);
            setSelectedSubCategorySlug(slug); // Set slug when subcategory is selected
            setCategoryForProductSelect(categoryId);
            setSelectedProduct(null);
            setResult(null);

            //const params = new URLSearchParams(location.search);
            //params.delete('product');
            //navigate({ search: params.toString() }, { replace: true });
        }
    };

    useEffect(() => {
        if (selectedParentCategory && (subCategories.length === 0 || selectedSubCategory)) {
            setCategoryForProductSelect(selectedSubCategory || selectedParentCategory);
        }
    }, [selectedParentCategory, subCategories, selectedSubCategory]);

    useEffect(() => {
        if (selectedParentCategory && subCategories.length === 0) {
            setCategoryForProductSelect(selectedParentCategory);
        }
    }, [selectedParentCategory, subCategories]);

    const initializeProductSelection = (product) => {
        // Avoid resetting state if the product is already selected
        if (selectedProduct && selectedProduct.id === product.id) return;
    
        const productCategories = product.categories;
    
        if (productCategories && productCategories.length > 0) {
            const parentCat = categories.find(cat =>
                productCategories.includes(cat.id) && cat.parent === 0
            );
    
            if (parentCat) {
                setSelectedParentCategory(parentCat.id);
            }
    
            const subCat = categories.find(cat =>
                productCategories.includes(cat.id) && cat.parent === parentCat?.id
            );
    
            if (subCat) {
                setSelectedSubCategory(subCat.id);
                setSelectedSubCategorySlug(subCat.slug); // Set the slug
            } else {
                setSelectedSubCategory(null);
                setSelectedSubCategorySlug('');
            }
    
            setCategoryForProductSelect(subCat ? subCat.id : parentCat?.id);
            setSelectedProduct(product);
        }
    };

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <section>
            <MenuModal isOpen={isMenuOpen} onClose={toggleMenu} quoteHistory={quoteHistory} setQuoteHistory={setQuoteHistory} />
            <div>
                <div className='sticky-banner'>
                    <div className='mobile-title'>U-VALUE CALCULATOR</div>
                    <div style={{ display: "flex" }}>
                        <button style={{ backgroundColor:"#00000000", border:"none", cursor:"pointer" }} onClick={() => toggleMenu()}>
                            <img className='menu-icon' src='Menu.png' />
                        </button>
                    </div>
                </div>
            </div>
            <div className='ui-container uk-container uk-margin-large-top'>
                <div className='desktop title-logo'>
                    <div style={{ fontSize:"42px", color:"#333" }} >U-Value Calculator</div>
                    <a href='https://mannokbuild.com' target='_blank'><img style={{ height:"80px" }} src="https://uvalue-calculator.nimbus.sugarprojects.com/wp-content/uploads/2024/09/Mannok_Logo.png"/></a>
                </div>
                <div className='left-right-cont'>
                    <div className='left-cont'>
                        {error && <p style={{ color: 'red' }}>{error}</p>}

                        <div style={{marginBottom: "50px"}}>
                            <h4>Welcome to the U-Value Calculator</h4>
                            <p>Achieving strong thermal performance starts with getting your U-values right. This page gives you everything you need to do that effectively, offering quick access to intuitive calculation tools alongside guidance that helps you make informed design choices. It’s designed to support you in building smarter, working faster, and delivering better energy efficiency in every project.</p>
                        </div>

                        <div className="uk-margin-bottom">
                            <div className="uk-margin-small-bottom cat-grid">
                                <div>
                                    <label className="uk-form-label uk-display-block uk-margin-small-top">
                                        Construction Type
                                    </label>
                                    <div className="mobile-cat-buttons-grid">
                                    {parentCategories.map((category) => (
                                        <label
                                        key={category.id}
                                        className={`mobile-cat-button ${selectedParentCategory === category.id ? 'active' : ''}`}
                                        >
                                        <div className="mobile-cat-content">
                                            <img src={category?.acf?.image_url} alt={category.name} className="mobile-cat-image" />
                                            <div className='button-name'>
                                                <input
                                                    type="radio"
                                                    name="category"
                                                    value={category.id}
                                                    checked={selectedParentCategory === category.id}
                                                    onChange={() => handleParentCategorySelect(category.id)}
                                                    className="mobile-cat-radio"
                                                />
                                                <div className="mobile-cat-name">{category.name}</div>
                                            </div>
                                        </div>
                                        </label>
                                    ))}
                                    </div>
                                </div>
                            </div>
                        </div>



                        {/* Mobile Product Accordion */}
                        <div>
                            {selectedParentCategory && (
                                <MobileProductAccordion 
                                    selectedParentCategory={selectedParentCategory}
                                    categories={categories}
                                    onProductSelect={setSelectedProduct} 
                                    setResult={setResult}
                                    result={result}
                                    product={selectedProduct}
                                    allProducts={posts}
                                    setSelectedProduct={setSelectedProduct}
                                    setSelectedSubCategory={setSelectedSubCategory}
                                    setSelectedSubCategorySlug={setSelectedSubCategorySlug}
                                    newQuote={newQuote}
                                />
                            )}
                        </div>

                        <div className="uk-margin-top">
                            {selectedProduct && (
                                <ProductVariables 
                                    product={selectedProduct} 
                                    setResult={setResult} 
                                    result={result} 
                                    newQuote={newQuote}
                                    setProductUrlParent={setProductUrl}
                                    setFormDataParent={setFormData}
                                />
                            )}
                        </div>
                    </div>
                    <div className='right-cont'>
                        <MobileProductDisplay product={selectedProduct} result={result} newQuote={newQuote} productUrl={productUrl} formData={formData}/>
                        
                        <p className='uk-text-meta uk-margin-medium' style={{ fontSize: "10px" }}>
                            Whilst the information and/or specification contained here is to the best of our knowledge true and accurate, we specifically exclude any liability for errors, omissions or otherwise arising therefrom. Details, practices, principles, values and calculations should be verified as to accuracy and suitability for the required purpose for use.
                        </p>
                    </div>
                </div>
            </div>
            <div style={{width: "100%", backgroundColor: "#F6F7F9", display: "flex", justifyContent: "center", fontSize: "20px"}}>
                <div className='ui-container uk-container uk-margin-large-top uk-margin-large-bottom uvalue-flex'
                    style={{display: "flex", alignItems: "center", gap: "30px"}}>

                    <div className="app-vid" style={{flex: 1}}>
                        <img style={{height: "800px"}} src="https://uvalue-calculator.nimbus.sugarprojects.com/wp-content/uploads/2025/12/Untitled-design.gif" />
                    </div>

                    <div style={{flex: 1}}>
                        <h2>Let Us Help You With Your U-Value Calculations.</h2>
                        <p>Mannok provides a free online U-value calculator, available at mannokbuild.com, as well as a downloadable app for both iOS and Android devices (scan the QR code on this page to download the Mannok U-Value Calculator App).</p>
                        <p>Both tools offer an easy-to-use, reliable solution for calculating U-values for the most common construction types.</p>
                        <p>If you need additional assistance, Mannok's Technical Team is available to help with bespoke U-value calculations:</p>
                        <p><a href="mailto:info@mannokbuild.com" style={{color: "#333"}}><img src="https://uvalue-calculator.nimbus.sugarprojects.com/wp-content/uploads/2025/12/Vector-2.png" style={{marginRight: "12px", width: "30px"}}/>info@mannokbuild.com</a></p>
                        <p><a href="tel:+448000322122" style={{color: "#333"}}><img src="https://uvalue-calculator.nimbus.sugarprojects.com/wp-content/uploads/2025/12/Vector-1.png" style={{marginRight: "12px", width: "30px"}}/>08000 322 122 (UK)</a></p>
                        <p><a href="https://mannokbuild.com/mannok-launches-its-u-value-calculator-app/" style={{color: "#6294AA"}}>View Article</a></p>
                    </div>

                </div>
            </div>

            <div style={{width: "100%", backgroundColor: "#6294AA", fontSize: "20px", color: "#fff"}}>
                <div className='ui-container uk-container'>
                    <FAQAccordion />
                </div>
            </div>

        </section>
    );
};

export default WordPressPosts;

const FAQAccordion = () => {
  const faqs = [
    {
      q: "What is a U-value?",
      a: `A U-value measures the rate of heat transfer through a building element such as a floor, wall, or roof. It is expressed in Watts per square metre Kelvin (W/m²K).

A lower U-value indicates better insulation and less heat loss, improving the energy efficiency of a building.`,
    },
    {
      q: "What are U-values used for?",
      a: `U-values play a key role in building regulations, which set minimum thermal performance standards for new builds, extensions, and renovations. These standards help ensure good energy efficiency and lower heating costs.

A growing focus on sustainability and whole-life carbon of buildings has also contributed in driving U-values lower.`,
    },
    {
      q: "Do insulation boards have a U-value?",
      a: `No. Individual insulation boards do not have a U-value. Instead, the overall building element (e.g., wall, roof, or floor) has a U-value, which is influenced by the type and thickness of insulation used. 

Insulation performance is expressed as thermal conductivity (lambda value) - a measure of how easily heat passes through a material - or as thermal resistance, which factors in both conductivity and thickness.`,
    },
    {
      q: "How can I achieve a better U-value?",
      a: `You can improve a building element’s U-value by: 
- Increasing the thickness of the insulation, and/or 
- Using a higher-performing insulation with a lower thermal conductivity. `,
    },
    {
      q: "How is a U-value calculated?",
      a: `A U-value is the inverse of the total thermal resistance of all layers within a building element, including the internal and external surface resistances. 
The thermal resistance of each layer is calculated by dividing its thickness (in metres) by its thermal conductivity.

Example: 
For 100 mm of Mannok Therm QF insulation: 
0.1 m ÷ 0.022 W/m·K = 4.545 m²K/W 

Thermal bridging elements - such as wall ties, fixings, or timber/steel studs - also significantly affect U-values and must be included in the calculation. Because this can be complex, we recommend using online tools or consulting a qualified technical advisor. `,
    },
  ];

  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div style={{ width: "100%", maxWidth: "900px", margin: "0 auto", padding: "60px 0", color: "white" }}>
      <h2 style={{ marginBottom: "40px", color:"#fff" }}>
        Frequently Asked Questions
      </h2>

      {faqs.map((item, i) => {
        const isOpen = openIndex === i;

        return (
          <div key={i} style={{ borderBottom: "1px solid rgba(255,255,255,.35)", padding: "20px 0" }}>
            <button
              onClick={() => setOpenIndex(isOpen ? null : i)}
              style={{
                width: "100%",
                background: "none",
                border: "none",
                color: "white",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "20px",
                fontWeight: "500",
                cursor: "pointer",
                padding: 0,
                textAlign: "left",
              }}
            >
              {item.q}

              <div
                style={{
                  width: "28px",
                  height: "28px",
                  padding: "10px",
                  borderRadius: "50%",
                  background: "white",
                  color: "#6294AA",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "transform 0.25s ease",
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                  fontSize: "20px",
                }}
              >
                <img src="https://uvalue-calculator.nimbus.sugarprojects.com/wp-content/uploads/2025/12/Vector-175-Stroke.png" />
              </div>
            </button>

            <div
              style={{
                maxHeight: isOpen ? "500px" : "0px",
                overflow: "hidden",
                transition: "all 0.35s ease",
              }}
            >
              <p
                style={{
                  marginTop: "15px",
                  fontSize: "18px",
                  lineHeight: "1.55",
                  whiteSpace: "pre-line",
                  opacity: isOpen ? 1 : 0,
                  transition: "opacity 0.25s ease",
                }}
              >
                {item.a}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};